import React, { useState, useEffect, useRef } from 'react'
import { FlexGrid, Box, Typography } from '@telus-uds/components-web'
import { LegalTextRenderer } from '../../../utils/text/TextRenderer'
import {
  StickyNavContainer,
  StickyCartContainer,
  StickyHeaderContainer,
  PlanSectionContainer,
  CartContainer,
  CartComponent,
} from './Styles'

export type StickyCartV2Props = {
  componentHeader?: string
  heroImage?: React.ReactNode
  cart?: React.ReactNode
  stickyNav?: React.ReactNode
  stickyCardsHeading?: string
  planCardSection?: React.ReactNode
  componentSubHeader?: string
}

const StickyCartV2 = ({
  componentHeader,
  componentSubHeader,
  heroImage,
  cart,
  stickyNav,
  stickyCardsHeading,
  planCardSection,
}: StickyCartV2Props) => {
  const [visible, setVisible] = useState(false)
  const [visibility, setVisibility] = useState(false)
  const stickyRef = useRef<HTMLDivElement>(null)

  /* istanbul ignore next */
  // TODO: improve coverage and remove the ignore
  useEffect(() => {
    setVisibility(true)
    const currentObserver = new IntersectionObserver((entries) => {
      if (
        // if mobile breakpoint && only one entry exist && sticky cart is not intersecting
        (stickyRef.current &&
          entries.length === 1 &&
          !entries[0].isIntersecting &&
          stickyRef.current.getBoundingClientRect().top < 0) ||
        // if desktop breakpoint && only one entry exist && sticky cart is not intersecting
        (!stickyRef.current && entries.length === 1 && !entries[0].isIntersecting)
      ) {
        setVisible(true)
      } else {
        setVisible(false)
      }
    })

    if (stickyRef.current) {
      currentObserver.observe(stickyRef.current)
    }
  }, [])

  return (
    <section data-testid={'stickyCart-testid'}>
      <StickyNavContainer visible={visible}>{stickyNav}</StickyNavContainer>
      <FlexGrid gutter={false}>
        <StickyCartContainer>
          <StickyHeaderContainer visibility={visibility}>
            <Box vertical={4} horizontal={3}>
              <div style={{ paddingBottom: 20 }}>
                <Typography block variant={{ size: 'h1' }} heading="h1">
                  <LegalTextRenderer>{componentHeader}</LegalTextRenderer>
                </Typography>
              </div>
              {componentSubHeader && (
                <div style={{ paddingBottom: 32 }}>
                  <Typography block variant={{ colour: 'dark' }}>
                    <LegalTextRenderer>{componentSubHeader}</LegalTextRenderer>
                  </Typography>
                </div>
              )}
              {heroImage}
            </Box>
          </StickyHeaderContainer>
          <PlanSectionContainer visibility={visibility}>
            <Box vertical={2} horizontal={3}>
              {stickyCardsHeading && (
                <Typography block variant={{ size: 'h2' }} heading="h2">
                  {stickyCardsHeading}
                </Typography>
              )}
            </Box>
            <div style={{ paddingLeft: '16px', paddingRight: '16px' }} data-testid={'planSection-id'}>
              {planCardSection}
            </div>
          </PlanSectionContainer>
          <CartContainer visibility={visibility}>
            <CartComponent ref={stickyRef}>{cart}</CartComponent>
          </CartContainer>
        </StickyCartContainer>
      </FlexGrid>
    </section>
  )
}

export default StickyCartV2
